
import axios from "axios";
import { apiPath } from "../../constants/config";

let token = localStorage.getItem("accessToken");
let config = {
  headers: {
    Authorization: "Bearer " + token
  }
};

let cure;
export default {
  state: {
    currentUser:
      localStorage.getItem("user") != null
        ? JSON.parse(localStorage.getItem("user"))
        : {},
    currentUserInfos:
      localStorage.getItem("userInfo") != null
        ? JSON.parse(localStorage.getItem("userInfo"))
        : {},

//client
    currentClient:
      (localStorage.getItem("client") && localStorage.getItem("client")!='undefined' )
        ? JSON.parse(localStorage.getItem("client"))
        : {},
        
    currentClientInfos:
      (localStorage.getItem("clientInfo") && localStorage.getItem("clientInfo")!='undefined')
        ? JSON.parse(localStorage.getItem("clientInfo"))
        : {},



    loginError: null,
    processing: false,
    forgotMailSuccess: null,
    resetPasswordSuccess: null,
    users: [],
    visiteurs: [],
    visiteursPages: 0,
    isLoadUsers: false
  },
  getters: {
    isLoadUsers: state => state.isLoadUsers,
    users: state => state.users.filter(user => user.role == "ADMIN"),
    clients: state => state.users.filter(user => user.role == "USER"),
    currentUser: state => state.currentUser,
    currentUserInfos: state => state.currentUserInfos,

    currentClient: state => state.currentClient,
    currentClientInfos: state => state.currentClientInfos,

    visiteurs: state => state.visiteurs,
    visiteursPages: state => state.visiteursPages,
    processing: state => state.processing,
    loginError: state => state.loginError,
    forgotMailSuccess: state => state.forgotMailSuccess,
    resetPasswordSuccess: state => state.resetPasswordSuccess
  },
  mutations: {
    setUserInfo(state, payload) {
      console.log("FROMM MUTAE");
      console.log(payload);
      state.currentUserInfos = payload;
      const item = {
        uid: payload.email,
        name: `${payload.firstName} ${payload.lastName}`,
        role: payload.role,
        permissions: payload.pack
      };
      state.currentUser = item;
      localStorage.setItem("user", JSON.stringify(item));
      localStorage.setItem("userInfo", JSON.stringify(payload));
    },
    setUser(state, payload) {
      state.currentUser = payload;
      state.processing = false;
      state.loginError = null;
    },


    setClient(state, payload) {
      state.currentClient = payload;
      state.processing = false;
      state.loginError = null;
    },


    setLogout(state) {
      state.currentUser = null;
      state.processing = false;
      state.loginError = null;
    },
    setProcessing(state, payload) {
      state.processing = payload;
      state.loginError = null;
    },
    setError(state, payload) {
      state.loginError = payload;
      state.currentUser = null;
      state.processing = false;
    },
    setForgotMailSuccess(state) {
      state.loginError = null;
      state.currentUser = null;
      state.processing = false;
      state.forgotMailSuccess = true;
    },
    setResetPasswordSuccess(state) {
      state.loginError = null;
      state.currentUser = null;
      state.processing = false;
      state.resetPasswordSuccess = true;
    },
    getUsersSuccess(state, payload) {
      state.isLoadUsers = true;
      state.users = payload;
    },
    getVisiteursSuccess(state, payload) {
      state.isLoadUsers = true;
      state.visiteurs = payload.data;
      state.visiteursPages = payload.total;
    },
    clearError(state) {
      state.loginError = null;
    }
  },
  actions: {
    clearLoginError({ commit }, payload) {
      commit("clearError");
      commit("setProcessing", false);
    },
    // login({ commit }, payload) {
    //   commit("clearError");
    //   commit("setProcessing", true);
    //   localStorage.clear();
    //   localStorage.removeItem("userInfo");
    //   localStorage.removeItem("accessToken");
    //   localStorage.removeItem("user");
    //   axios
    //     .post(`${apiPath}/auth`, payload)
    //     .then(r => r.data)
    //     .then(data => {
    //       if (data.ok) {
    //         localStorage.setItem("userInfo", JSON.stringify(data.user));
    //         localStorage.setItem("accessToken", data.data.token);

    //         config = {
    //           headers: {
    //             Authorization: "Bearer " + data.data.token
    //           }
    //         };
    //         const item = {
    //           uid: payload.email,
    //           name: `${data.user.firstName} ${data.user.lastName}`,
    //           role: data.user.role,
    //           permissions: data.user.pack
    //         };
    //         localStorage.setItem("user", JSON.stringify(item));
    //         commit("setUser", item);
    //       } else {
    //         commit("setError", data.message);
    //       }
    //     });
    // },
    login({ commit }, payload) {
      commit("clearError");
      commit("setProcessing", true);
      localStorage.clear();
      localStorage.removeItem("clientInfo");
      localStorage.removeItem("accessToken");
      localStorage.removeItem("client");
      axios
        .post(`${apiPath}/login`, payload)
        .then(r => r.data)
        .then(data => {
          if (data.ok) {
            localStorage.setItem("clientInfo", JSON.stringify(data.client));
            localStorage.setItem("accessToken", data.data.token);

            config = {
              headers: {
                Authorization: "Bearer " + data.data.token
              }
            };
            const item = {
              email: payload.email,
              // name: `${data.client.prenom} ${data.client.nom}`,
              // role: data.user.role,
              password: payload.password,
              type: payload.type,
            };
            console.log(item)
            localStorage.setItem("client", JSON.stringify(item));
            commit("setClient", item);
          } else {
            commit("setError", data.message);
          }
        });
    },
    getUsers({ commit }, payload) {
      axios
        .get(`${apiPath}/users`, config)
        .then(r => r.data)
        .then(data => {
          if (data.ok) {
            commit("getUsersSuccess", data.data);
          }
          return data;
        });
    },
    getVisiteurs({ commit }, payload) {
      axios
        .get(
          `${apiPath}/visiteurs/${payload.restaurant}?limit=${payload.limit}&page=${payload.page}&date=${payload.date}`,
          config
        )
        .then(r => r.data)
        .then(data => {
          if (data.ok) {
            commit("getVisiteursSuccess", data);
          }
          return data;
        });
    },

    sendMessage({ commit }, payload) {
      axios
        .post(`${apiPath}/sendMessage/${payload.restaurant}`, payload, config)
        .then(r => r.data)
        .then(data => {
          return data;
        });
    },
    getUser({ commit }, payload) {
      token = localStorage.getItem("accessToken");
      config = {
        headers: {
          Authorization: "Bearer " + token
        }
      };
      console.log(`%c TOKEN : ${token}`, "color : red; font-size: 20px");
      return axios
        .get(`${apiPath}/users/checkAuth`, config)
        .then(r => r)
        .catch(data => data);
    },
    register({ commit }, payload) {
      // if (!payload.role) {
      //   payload.role = "USER";
      // }
      return axios
        .post(`${apiPath}/signup`, payload)
        .then(r => r)
        .catch(data => data);
    },
    editProfileUser({ commit }, payload) {
      return axios
        .put(`${apiPath}/users/${payload._id}`, payload, config)
        .then(r => r)
        .catch(data => data);
    },
    editUserPack({ commit }, payload) {
      if (!payload.pack) {
        console.log(payload.pack);
        payload.pack = "";
      }
      return axios
        .post(`${apiPath}/users/editUserPack/${payload._id}`, payload, config)
        .then(r => r)
        .catch(data => data);
    },
    changeUser({ commit }, payload) {
      axios
        .post(`${apiPath}/users/change`, payload, config)
        .then(r => r.data)
        .then(data => {
          return data;
        });
    },
    forgotPassword({ commit }, payload) {
      commit("clearError");
      commit("setProcessing", true);
      return axios
        .post(`${apiPath}/users/forgotPassword`, payload)
        .then(r => r)
        .catch(data => data);
    },
    checkUrlRoute({ commit }, payload) {
      return axios
        .get(`${apiPath}/checkUrlRoute?vkey=${payload.vkey}`)
        .then(r => r)
        .catch(data => data);
    },
    resetPassword({ commit }, payload) {
      commit("clearError");
      commit("setProcessing", true);
      return axios
        .post(`${apiPath}/users/resetPassword`, payload)
        .then(r => r)
        .catch(data => data);

    },

    /*
       return await auth.(resetPasswordCode, newPassword)
        .then(user => user)
        .catch(error => error);
    */
    async signOut({ commit }) {
      await localStorage.clear();
      await localStorage.removeItem("userInfo");
      await localStorage.removeItem("accessToken");
      await localStorage.removeItem("user");

      return { ok: true }
    }
  }
};
